export default __webpack_public_path__ + "static/media/visa-logo.30c97d85.svg";